import EditIcon from '@mui/icons-material/Edit';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MeinBereichButton, MeinBereichPaper } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import { PAGES_URLS } from '../../../../lib/constants/routes';

function BeendeteForderung() {
	const navigate = useNavigate();
	return (
		<>
			<MeinBereichPaper titleIcon={<EditIcon />} title={'Beendete Förderung'}>
				<MeinBereichButton buttonName='Förderarchiv ansehen' disabled={true} />
				<MeinBereichButton
					buttonName='Abschlussbericht einreichen'
					onClick={() => {
						navigate(`${PAGES_URLS.MeineFoerderung}`, {
							state: {
								filter: {
									items: [
										{
											field: 'Antragstatus_Antragstatus',
											operator: 'is',
											value: 'Projekt beendet',
										},
									],
								},
							},
						});
					}}
				/>
				<MeinBereichButton buttonName='Nachweise zur Zweckbindungsfrist einreichen' disabled={true} />
			</MeinBereichPaper>
		</>
	);
}

export default BeendeteForderung;
